import React from "react";
import { numberAsStringWithLimit } from "../../../utils/numberFormatter";
import styles from "./simpleIndicator.css";

interface Props {
  count: number;
}
export const SimpleIndicator = ({ count }: Props) => (
  <div className={styles.counter}>{numberAsStringWithLimit(count)}</div>
);
